module.exports = __webpack_public_path__ + "media/images/institutions_logos-8e07023a62e4064db6986d11e68a06ff.png";